import { useEffect, useState } from 'react'
import { DesktopOnlyGate } from './components/DesktopOnlyGate.js'
import { HandlePicker } from './components/HandlePicker.js'
import { TopBar } from './components/TopBar.js'
import { Field } from './components/Field/Field.js'
import { Toasts } from './components/Toasts.js'
import { LiquidatedSplash } from './components/LiquidatedSplash.js'
import { Leaderboard } from './components/Leaderboard.js'
import { connect } from './socket.js'
import { loadIdentity } from './identity.js'
import { useStore } from './store.js'

export function App() {
  const status = useStore((s) => s.status)
  const self = useStore((s) => s.self)
  const [pickerError, setPickerError] = useState<string | null>(null)
  const [handleSubmitted, setHandleSubmitted] = useState(false)

  // Auto-connect on first load if we have a saved identity.
  useEffect(() => {
    const id = loadIdentity()
    if (id) {
      connect({ display_handle: id.display_handle, token: id.auth_token })
      setHandleSubmitted(true)
    }
  }, [])

  // Show auth-fail message back in the picker.
  useEffect(() => {
    if (status === 'auth_failed') {
      setHandleSubmitted(false)
      setPickerError('That handle is taken or invalid — try another.')
    }
  }, [status])

  function onPick(display_handle: string) {
    setPickerError(null)
    setHandleSubmitted(true)
    connect({ display_handle })
  }

  return (
    <DesktopOnlyGate>
      {status === 'replaced' ? (
        <main className="min-h-screen flex items-center justify-center px-4 text-center">
          <p className="text-body text-grey max-w-sm">
            This session was opened in another tab. Refresh to reclaim.
          </p>
        </main>
      ) : !handleSubmitted || !self ? (
        <HandlePicker onSubmit={onPick} error={pickerError} />
      ) : (
        <div className="min-h-screen flex flex-col">
          <TopBar />
          <Field />
          <Leaderboard />
          <Toasts />
          <LiquidatedSplash />
        </div>
      )}
    </DesktopOnlyGate>
  )
}
